import config from 'config';
import axios from 'axios';

const ROOT = config.API_BASE_URL;

class DeviceStatusesService {

  static getAll() {
    return new Promise((resolve, reject) => {
      axios.get(`${ROOT}device_statuses`).then((data) => {
        resolve({ deviceStatuses: data.data, response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

}

export default DeviceStatusesService;
